import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand, PoweredBy } from "@/components/Brand";
import { Lock, Mail, Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) nav("/admin");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="hidden md:flex md:w-1/2 bg-[#8B0000] text-white p-12 flex-col justify-between">
        <Brand dark />
        <div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold leading-tight">Loyalty that<br />rewards every<br />brushstroke.</h1>
          <p className="mt-5 text-white/70 text-lg max-w-sm">Manage painters, dealers, coupons, wallets, UPI payouts and campaigns — one connected platform.</p>
        </div>
        <PoweredBy className="text-white/50" />
      </div>
      <div className="flex-1 flex items-center justify-center p-6 bg-gray-50">
        <form onSubmit={submit} className="w-full max-w-sm bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-testid="login-form">
          <div className="md:hidden mb-6"><Brand /></div>
          <h2 className="font-display text-2xl font-bold text-gray-900">Admin Sign In</h2>
          <p className="text-sm text-gray-500 mt-1 mb-6">Access the Jewell Rewards portal</p>
          {error && <div className="mb-4 text-sm bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2" data-testid="login-error">{error}</div>}
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
          <div className="relative mb-4">
            <Mail className="absolute left-3 top-3.5 h-4 w-4 text-gray-400" />
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000] outline-none" placeholder="you@jewellpaints.com" />
          </div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
          <div className="relative mb-6">
            <Lock className="absolute left-3 top-3.5 h-4 w-4 text-gray-400" />
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B0000] focus:border-[#8B0000] outline-none" placeholder="••••••••" />
          </div>
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-[#8B0000] hover:bg-[#6B0000] text-white font-bold py-3.5 rounded-lg transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign In
          </button>
          <p className="mt-5 text-center"><PoweredBy /></p>
        </form>
      </div>
    </div>
  );
}
